import { Inject, Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';
import { tap } from 'rxjs/operators';

import { StorageService } from '@coin-depo-core/storage';
import { AUTH_SERVICE_TOKEN, AuthFacade } from '@coin-depo-core/auth';
import { FOUNDS_API } from './founds.token';
import { FoundsApi } from './founds.api.interface';

import { SourceOfFound } from '@coin-depo-types';



@Injectable({
  providedIn: 'root',
})
export class FoundsService {
  private sourceOfFunds$ = new BehaviorSubject<SourceOfFound[]>(
    this.storage.get('sourceOfFunds', [])
  );
  cachedSourceOfFunds$ = this.sourceOfFunds$.asObservable();

  constructor(
    private storage: StorageService,
    @Inject(FOUNDS_API) private apiService: FoundsApi,
    @Inject(AUTH_SERVICE_TOKEN) private authService: AuthFacade,
  ) {}

  getSourceOfFundsSnapshot() {
    return this.sourceOfFunds$.value;
  }

  updateSourceOfFunds() {
    return this.apiService
      .getSourceOfFunds({
        username: this.authService.userData.username!,
        client_token: this.authService.accessToken,
      })
      .pipe(
        tap((res) => {
          this.sourceOfFunds$.next(res.source_of_funds);
          this.storage.set('sourceOfFunds', res.source_of_funds);
        })
      );
  }
}
